export default {"src":"/_next/static/media/ups.99b0fcd7.svg","height":24,"width":21,"blurWidth":0,"blurHeight":0};